var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{fill:#b42025}.cls-2{fill:none}.cls-3{fill:#fff}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    youtube-color\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15 29A14 14 0 1 0 1 15a14 14 0 0 0 14 14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-3",
    d: "M12 18.07h-.9v-.52a1.33 1.33 0 0 1-.95.59.57.57 0 0 1-.57-.37 1.91 1.91 0 0 1-.1-.7v-3.8h.9v3.89c0 .13.08.18.19.18s.33-.15.52-.42v-3.65H12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "cls-3",
    d: "M8.8 14.84a1.91 1.91 0 0 0-.28-1.14 1.2 1.2 0 0 0-1-.46 1.14 1.14 0 0 0-1 .46 1.91 1.91 0 0 0-.28 1.14v1.71a1.77 1.77 0 0 0 .27 1.1 1.26 1.26 0 0 0 1 .5 1.27 1.27 0 0 0 1-.5 1.79 1.79 0 0 0 .27-1.1zm-.9 1.8c0 .47-.1.71-.38.71s-.43-.24-.38-.71v-1.9c0-.47.1-.7.38-.7s.43.22.38.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-3",
    d: "M5.24 15.46v2.61h-.95v-2.61s-1-3.2-1.19-3.8h1l.67 2.5.66-2.5h1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.27 14a.67.67 0 0 0-.45.22v2.88a.66.66 0 0 0 .45.22c.25 0 .36-.18.36-.66v-2c0-.48-.12-.66-.36-.66zm3.54.61c0-.44-.11-.57-.4-.57s-.41.12-.41.56v.53h.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.76 12.18a3 3 0 0 0-.56-1.4 2 2 0 0 0-1.42-.6c-2-.14-5-.14-5-.14s-3 0-5 .14a2 2 0 0 0-1.42.6 3 3 0 0 0-.56 1.4 21.26 21.26 0 0 0-.14 2.29v1.07a21.26 21.26 0 0 0 .14 2.29 3 3 0 0 0 .56 1.4 2.41 2.41 0 0 0 1.56.6c1.13.11 4.82.14 4.82.14s3 0 5-.15a2 2 0 0 0 1.42-.6 3 3 0 0 0 .56-1.4 21.28 21.28 0 0 0 .14-2.29v-1.07a21.29 21.29 0 0 0-.1-2.28zm-10.93 5.89h-.95v-5.46h-1v-.9h3v.9h-1zm3.42 0h-.9v-.52a1.33 1.33 0 0 1-.95.59.57.57 0 0 1-.57-.37 1.91 1.91 0 0 1-.1-.7v-3.75h.9v3.85c0 .13.08.18.19.18s.33-.15.52-.42v-3.61h.9zm3.28-1.42a3.65 3.65 0 0 1-.09.95.71.71 0 0 1-.71.54 1.22 1.22 0 0 1-.91-.54v.48H20v-6.37h.85v2.08a1.23 1.23 0 0 1 .91-.54.7.7 0 0 1 .69.55 3.33 3.33 0 0 1 .12.95zm1.89.7a.37.37 0 0 0 .38-.35v-.6h.9v.13a5.41 5.41 0 0 1 0 .56 1.22 1.22 0 0 1-.2.52 1.19 1.19 0 0 1-1 .51 1.23 1.23 0 0 1-1-.49 1.76 1.76 0 0 1-.3-1.09v-1.65a1.91 1.91 0 0 1 .29-1.14 1.23 1.23 0 0 1 1-.5 1.2 1.2 0 0 1 1 .5 1.86 1.86 0 0 1 .28 1.12v1H24v.85c0 .41.12.63.42.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconYoutube);
export default __webpack_public_path__ + "static/media/social-icon-youtube.cff20b4666eafb5fde21f51a03390a07.svg";
export { ForwardRef as ReactComponent };